export default {
  common: {
    campany: 'COMPANY',
    ourStory: 'ARTIST',
    audition: 'AUDITION',
    contact: 'CONTACT',
    information: 'INFORMATION',
    blix: 'BLIX CREATES THE FUTURE OF ENTERTAINMENT —',
    makingTomorrow: 'MAKING TOMORROW’S',
    inspirations: 'INSPIRATIONS POSSIBLE TODAY',
    home: 'HOME',
    copyrightBlix: '© Copyright Blix Entertainment. ALL RIGHT RESERVED',
    standsFor: '"BLIX" STANDS FOR',
    brilltance: 'BRILLIANCE.',
    speed: 'SPEED.',
    stability: 'STABILITY.',
    vitality: 'VITALITY.',
    tip: 'BLIX是一家面向未来的创意型全球娱乐公司，致力于艺人发掘、培养、音乐制作和技术创新。通过将音乐制作与技术革新相结合，我们打造一个涵盖具有全球竞争力内容与创新性叙事的综合生态体系。我们将在全球舞台上，成为引领韩国娱乐业新标准的企业。 ',
    tip1: '我们相信创造力是我们持久的力量，而BLIX正凭借这股力量推动世界前进。创造力不断燃烧，以不竭的能量为世界带来新的灵感。',
    tip2: 'BLIX通过系统化的娱乐体系运作，把故事、艺人以及全球粉丝紧密相连，提供最优质的娱乐体验。',
    tip3: 'BLIX结合创造力与专业性，建立一套完善的体系。从艺人成长的每个阶段开始，提供专业培训，涵盖音乐制作、视觉叙事、品牌打造，直至全球舞台。通过这一坚固的系统，我们致力于建立系统化、可持续的娱乐产业长远影响力。',
    visionary: 'VISIONARY ENTERTAINMENT',
    tip4: '在瞬息万变的全球市场与创意经济中，BLIX构建了一个可持续且灵活的娱乐体系。每一个环节都以专业标准、人才培养与未来导向的愿景精心设计，指引着全新的娱乐方向。',
    atTheHeart:'在 BLIX 的核心，是无限的可能性与全新的愿景。', 
    wePrepare:'我们不仅追随潮流，更打造能够引领世代的文化舞台。', 
    togetherWeGrow:'携手成长， BLIX Entertainment 将成为世界舞台上的全新标杆。',
    ourCompleteSystem: 'OUR COMPLETE SYSTEM',
    casting: 'CASTING',
    trainingDevelopment: 'TRAINING & DEVELOPMENT',
    musicProduction: 'MUSIC PRODUCTION',
    brandingStoryIP: 'BRANDING & STORY IP',
    marketingFanSystem: 'MARKETING & FAN SYSTEM',
    globalBusiness: 'GLOBAL BUSINESS',
    crossIndustryCollaboration: 'CROSS-INDUSTRY COLLABORATION',
    weContinue: 'BLIX与文化创新者共同成长，合作领域包括',
    artists: 'ARTISTS',
    technologyDevelopers: 'TECHNOLOGTY',
    creativeStrategists: 'CREATIVE STRATEGISTS',
    weBelieve: 'BLIX与文化创新者共同成长，不仅致力于培养和支持艺术家的发展，还积极与以下领域合作。',
    atBlix:'在BLIX，我们相信，艺术家的梦想就是我们的未来。',
    thatFunture:'而这一未来，已在这里通过音乐与故事逐渐化为现实。',
    creativeSpace: 'CREATIVE SPACE',
    tip5: '你将被纳入 BLIX 的全球艺人企划，踏入专属的成长旅程，正式开启迈向世界焦点的序幕',
    spotlight: '加入BLIX —— 通往世界舞台的旅程，从这里开始。',
    blixShien: 'BLIX将为下一代艺人提供最优质的环境，让他们在专业训练中成长并闪耀光芒',
    tip20: '我们将通过音乐、视觉与强有力的叙事，打造属于新时代的创新表演。BLIX将毫无保留地培养所有怀揣梦想的艺人，让他们站上舞台中央，展现属于自己的故事。',
    forYou: '通往世界舞台的第一步，BLIX正在等待你',
    apllyNow: 'APLLY NOW',
    pleaseleave:'填写咨询后，我们的团队将在审核后回复您。',
    name:'姓名',
    email:'邮箱',
    contactNumber:'联系方式',
    inquiryDetails:'咨询内容',
    contact2:"CONTACT",
    agreePolicy:'我同意《个人信息处理方针》',
    submitInquiry:'提交咨询',
    seoulHq:'SEOUL HQ ',
    add:'6 SEONGMISAN-RO 6-GIL, ',
    add1:'MAPO-GU, SEOUL, ',
    add2:'REPUBLIC OF KOREA [03996]',
    add3:'서울특별시 마포구 성미산로6길 6 (망원동, BLIX 빌딩) ',
    hongKong:'HONG KONG OFFFICE',
    midtown:'1811, ONE MIDTOWN,',
    hoiShing:'11 HOI SHING ROAD, TSUEN WAN,',
    hongKong1:' HONG KONG',
    onlineAuditin:'在线试听指南',
    auditionCategories:'试镜类别',
    dataTyle:'声乐/说唱/舞蹈/表演',
    applicationPeriod:'报名时间',
    openYearRound:'全年开放', 
    eligibility:'报名资格', 
    noRestrictions:'不限 ', 
    howToApply:'如何申请',
    step1:'步骤 1',
    auditionForm:'点击“申请”，并填写完整试镜申请表。',
    step2:'步骤 2',
    uploadRequired:'上传文件',
    photos:'照片',
    clearPhoto:'1张半身正面照',
    frontView:'1张全身正面照',
    videoSubmission:'视频',
    videoAudio:'声乐/说唱：至少1分钟的歌曲或Rap表演（视频或音频）',
    freestyledancing:'舞蹈：至少1分钟自由舞蹈视频',
    actingPerformance:'表演：至少1分钟独白或演技视频',
    step3:'步骤 3',
    submityour:'提交申请以完成流程。',
    auditionProcess:'试镜流程',
    stRound:'1.    第一轮：资料审查',
    videoSubmissionReview:'审核申请表、照片及视频。',
    ndRound:'2.    第二轮：镜头测试',
    recordedVideoTest:'入选者将参加录制视频测试。',
    rdRound:'3.    最终轮：现场试镜与结果通知',
    afterThisRound:'最终候选人将被邀请至现场试镜，并在此阶段决定最终结果。',
    auditionResults:'试镜结果',
    tip6:'通过者将在试镜日期起两周内，收到申请表中填写的邮箱或电话的个人通知。',
    auditionResultsNotification:'试镜结果通知',
    tip7:'只有通过初选的申请者会收到联系，联系方式为报名表中提供的电子邮箱或电话号码。结果将在试镜日期后的两周内公布。',
    importantNotes:'注意事项',
    beReturned:'提交的资料一律不退还。',
    anyPhotosThat:'使用过度修图或滤镜的照片（如Photoshop修饰）可能导致淘汰。',
    videosAudio:'低画质的视频或音频（如模糊、对焦不准、音质差）可能对评审不利。',
    questionsFurther:'如有疑问或需要进一步帮助，请联系：',
    apply:'APPLY',
    pleaseEnter1:'请准确填写您的信息以申请试镜。',
    emailAddress:'电子邮箱',
    VerifyEmail:'验证邮箱',
    lastName:'姓氏',
    firstName:'名字',
    dateOfBirth:'出生日期',
    select:'请选择',
    enter:'请输入',
    profilePicture:'资料图片',
    upload:'上传',
    pleaseUpload:'请上传',
    performanceCategory:'表演类别',
    gender:'性别',
    height:'身高',
    height1:'身高(CM)',
    weight:'体重',
    weight1:'W体重(KG)',
    phone:'电话号码',
    phone1:'请填写表格',
    schoolJob:'学校/工作',
    schoolJob1:'请填写表格',
    emergencyContact:'紧急联系人',
    emergencyContact1:'请填写表格',
    placeOfresidence:'居住地',
    socialMediaId:'社交媒体账号',
    specialtv:'特长',
    activtiesAwarsds:'活动与奖项',
    activtiesExperience:'试镜经验',
    specialNote:'特别说明',
    attachFile:'附加文件',
    profileAttachFile:'个人资料附件',
    consentInformation:'我同意《个人信息处理方针》',
    submitApplicatior:'提交申请',
    tit1:'我同意《个人信息处理方针》',
    tip8:'申请人同意并授权 BLIX 娱乐（以下简称“公司”）收集和使用以下个人信息，用于下列目的。',
    tip9:"验证申请人身份、管理试镜申请、评估才能适配度、并进行练习生甄选。收集目的及类别收集目的及类别: 姓名、出生日期、国籍、住址、邮箱、联系方式、年龄、身高、体重、获奖及学历、学校与年级、社交媒体账号、照片与视频。",
    tip10:"验证申请人身份、管理试镜申请、评估才能适配度、并进行练习生甄选。收集项目：姓名、出生日期、国籍、住址、邮箱、联系方式、年龄、身高、体重、获奖及学历、学校与年级、社交媒体账号、照片与视频",
    tip11:"保留及使用期限: 自同意日起保存并使用 2 年，或至申请人书面撤回为止。申请人须及时告知公司任何变更。",
    tip12:"申请人应及时将所提供信息的任何更新或变更通知公司，公司有权在相同条件下收集并使用更新后的信息。",
    tip13:"拒绝同意可能导致申请无法处理或试镜相关程序无法进行，由此产生的不利后果完全由申请人自行承担。",
    tit2:'[个人信息委托第三方]',
    tip14:'委托目的：通过服务器安全托管和管理 BLIX 娱乐试镜平台及其相关数据。',
    tip15:"申请人有权拒绝第三方数据处理，但此类拒绝可能会限制申请人通过官方平台参加试镜的能力。",
    tit3:'[同意录制及使用内容]',
    tip16:'申请人同意公司在试镜过程中录制、拍摄其形象、声音和表演。所有录制资料（“内容”）可用于评估、内部使用、存档、人才培养，以及在签订练习生或专属协议时使用。',
    tit4:'[内容的知识产权]',
    tip17:'与内容相关的所有版权（包括衍生作品权利）、肖像权及任何其他知识产权，均由 BLIX ENTERTAINMENT 独家且全球享有。除非另有书面协议，申请人放弃对内容的所有权、版税或补偿的任何权利主张。',
    pleaseSelect:'请输入',
    pleaseCheck:'请勾选协议',
    submissionSuccessful :'提交成功',
    male:'男',
    female:'女',
    submissionFailed:'提交失败',
    pleaseEmailAddress:'请输入您的电子邮箱地址',
    sentSuccessfully:'发送成功',
    attachFile:'上传文件',
    imageFileSuch:'Image file such as .jpg .png/MAX 50MB',
    fileSize:'文件大小必须小于50MB！',
    fileSize1:'文件大小必须小于100MB！',
    uploadFailed:'上传失败',
    attach:'上传',
    emailVerification:'电子邮件验证发送失败',
    privacyPolicy:'私隐政策',
    tip21:'BLIX Entertainment（「本公司」）尊重您的私隐，并致力保护您的个人资料。本政策说明我们在您使用本网站及服务时，如何收集、使用、保存及保障您的资料。',
    tip22:'1. 收集的资料',
    tip23:'•	您在查询表格中提供的姓名、电邮、联络电话及其他资料。',
    tip24:'•	技术性资料，如 IP 位址、浏览器类型、存取纪录。',
    tip25:'2. 使用目的。',
    tip26:'•	回覆您的查询及提供客户支援。',
    tip27:'•	改善网站及服务质素。',
    tip28:'•	履行法律规定。',
    tip29:'3. 资料分享。',
    tip30:'•	我们不会出售或出租您的个人资料。',
    tip31:'•	我们只会在必要时与受信任的服务供应商分享资料，以便营运服务。',
    tip32:'•	法律要求时，可能披露相关资料。',
    tip33:'4. 资料保存',
    tip34:'•	资料仅会保存至达成上述目的所需的时间。',
    tip35:'5. 资料安全',
    tip36:'•	我们采取合理的安全措施保护您的资料，但不能保证绝对安全。',
    emailUnverified:'邮箱未验证',
    tip37:'BLIX HEADQUARTERS IS IN A MULTI-LEVELCREATIVE COMPLEX,WHERE EACH FLOORIS DEDICATED TO A SPECIALIZED FUNCTION-TRAINING, MUSICPRODUCTION, VISUAL DEVELOPMENT AND CONCEPT CREATION.',
    tip38:'创意与创新技术相融合，塑造下一阶段的娱乐形式。',
    year:'年份',
    award:'年份',
    categoryWork:'奖项 / 作品',
    brandOfTheYearAwards:'年度品牌大奖',
    femaleVocalist:'最佳女歌手',
    rdKYStarAwards:'第3届 KY Star Awards',
    millionSongLogs:'千万歌曲播放奖',
    gaonChartMusicAwards:'第9届 Gaon 音乐榜颁奖礼',
    discoveryoftheYearBallad:'年度发现奖（抒情歌）',
    melonMusicAwards:'Melon 音乐颁奖礼',
    topArtists:'TOP10 艺人',
    songDayWasBeautiful:'年度歌曲（大赏）–《那时候真好》',
    bestBallad:'最佳抒情歌',
    goldenDiscAwards:'第34届 金唱片颁奖礼',
    digitalBonsang:'数字本赏',
    seoulMusicAwards:'2第29届 首尔歌谣大赏',
    bonsangMainPrize:'本赏',
    popularityAward:'人气奖',
    KWaveAwards:'K-Wave Awards',
    bestAwardRewind:'最佳 R&B（作品《Rewind》）',
    koreaCulturalEntertainmentAwards:'韩国文化演艺大奖',
    kStarAward:'K-POP 明星奖',
    artistTheYear:'年度艺人',
    topArtistAward:'TOP10 艺人',
    bestFemaleSoloArtist:'最佳女歌手（Solo）',
    tip39:"BLIX大楼是一个融合培训、音乐与视觉制作的创意基地。",
    tip40:"在这里，灵感自由延展，创意不断进化。",
  },
};

